<template>
  <v-text-field v-model="color_value" :mask="mask"
                :label="label" :placeholder="placeholder"
                hide-details class="ma-0 pa-0"
                :outlined="outlined" :dense="dense">
    <template v-slot:append>

      <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16"
              :close-on-content-click="false" :close-on-click="false"
              @keypress.esc="keyPress_esc">

        <template v-slot:activator="{ on }">
          <div :style="swatchStyle" v-on="on"/>
        </template>

        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn icon @click="accept">
              <v-icon>done</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn icon @click="cancel">
              <v-icon>close</v-icon>
            </v-btn>

          </v-card-actions>
          <v-card-text class="pa-0">
            <v-color-picker v-model="color_value"
                            :swatches="swatches"
                            show-swatches>
            </v-color-picker>
          </v-card-text>
        </v-card>

      </v-menu>
    </template>

  </v-text-field>
</template>

<script>
	import format from 'string-format'

	export default {
		name: "color-picker-select",
		data: function () {
			return {
				mask: '!#XXXXXX',
				color_value: '#2020FF',
				menu: false,
				swatches: [
					['#FF0000', '#AA0000', '#550000'],
					['#FFFF00', '#AAAA00', '#555500'],
					['#00FF00', '#00AA00', '#005500'],
					['#00FFFF', '#00AAAA', '#005555'],
					['#0000FF', '#0000AA', '#000055'],
				]
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			label: {type: String, default: '',},
			placeholder: {type: String, default: '',},
			outlined: {type: Boolean, default: false},
			dense: {type: Boolean, default: false,},
			value: {type: String, default: '#000000'}
		},

		watch: {
			value: function (new_value, old_value) {
				console.debug(format("ColorPickerSelect.watch.value('{color}')", new_value))
				this.color_value = new_value
			},
		},

		computed: {
			swatchStyle() {
				const {color_value, menu} = this
				return {
					backgroundColor: color_value,
					cursor: 'pointer',
					height: '22px',
					width: '22px',
					borderRadius: menu ? '50%' : '4px',
					transition: 'border-radius 200ms ease-in-out',
					borderColor: 'black',
					borderWidth: '1px',

				}
			}
		},

		methods: {
			accept: function () {
				this.menu = false

				const color_str = this.color_value === null
					? null
					: typeof (this.color_value) === 'string'
						? this.color_value
						: this.color_value.hex

				this.$emit('input', color_str)
			},

			cancel: function () {
				this.menu = false
			},

			keyPress_esc: function () {
				console.debuge("ColorPickerSelect.keqPress_esc()")
			},
		}

	}
</script>

<style scoped>

</style>